import { POWUR_CARE_WARRANTY_FAMILY } from "../constants/finance"

// PowurOS warranty responses do not reliably carry a family field (see spec
// #4891), so Vision classifies a warranty's family from its provider-owned
// display name. This is the single classifier: gateway normalization and
// presentation gating both derive from it, never from a hard-coded warranty
// ID. A provider rename that drops the "powur care" phrase changes the
// classification — that fragility is the spec's accepted trade-off.
const WARRANTY_FAMILY_NAME_MATCHES = [
  { name: `powur care`, family: POWUR_CARE_WARRANTY_FAMILY },
  { name: `solaredge`, family: `solaredge` },
  { name: `solarinsure`, family: `solar_insure` },
] as const

export const classifyWarrantyFamily = (name: string): string => {
  const normalizedName = name.toLowerCase()

  return (
    WARRANTY_FAMILY_NAME_MATCHES.find(({ name: match }) =>
      normalizedName.includes(match),
    )?.family ?? `other`
  )
}

export const isPowurCareWarrantyName = (
  name: string | null | undefined,
): boolean =>
  name != null && classifyWarrantyFamily(name) === POWUR_CARE_WARRANTY_FAMILY
